export function getRandomSample(arr, count) {
    const copy = [...arr];
    for (let i = copy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy.slice(0, count);
  }
  
  export function shuffleArray(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
  }
  
  export function shuffleQuestionOptions(q) {
    const correctSet = new Set(q.correct.split(",").map(l => l.trim()));
    const entries = q.options.map((opt, idx) => ({
      text: opt,
      isCorrect: correctSet.has(String.fromCharCode(65 + idx))
    }));
    shuffleArray(entries);
    const newOptions = entries.map(e => e.text);
    const newCorrect = entries
      .map((e,i) => e.isCorrect ? String.fromCharCode(65 + i) : null)
      .filter(x => x)
      .join(",");
    return { ...q, options: newOptions, correct: newCorrect };
  }